import { ReactElement, useState } from 'react'

import { SelectTags } from 'components/v2/SelectTags'
import { GTBusinessClientAutocomplete, GTBusinessClientSuggestionsResponse } from 'gql/types.generated'
import { ISelectTagsProps } from 'components/v2/SelectTags/types'
import { GET_BUSINESS_CLIENTS_SUGGESTIONS } from 'features/BusinessClients/queries-legacy'
import { useDebouncedQuery } from 'components/v2/Autocomplete'
import { useLazyQuery } from '@apollo/client'

export interface IBusinessClientAutocomplete {
  id: string
  name: string
}

interface IMultiBusinessClientAutocompleteProps extends Omit<ISelectTagsProps, 'onChange' | 'items' | 'getTagLabel'> {
  onChange: (clients: IBusinessClientAutocomplete[]) => void
  companyId?: string
}

export const MultiBusinessClientAutocomplete = ({
  onChange,
  label,
  placeholder,
  values,
  companyId,
  ...props
}: IMultiBusinessClientAutocompleteProps): ReactElement => {
  const [pattern, setPattern] = useState('')
  const [getBusinessClients, { data, loading, error }] = useLazyQuery<{
    businessClientSuggestions: GTBusinessClientSuggestionsResponse
  }>(GET_BUSINESS_CLIENTS_SUGGESTIONS)
  const { isDebouncing, shouldShowItems } = useDebouncedQuery({
    query: getBusinessClients,
    pattern,
    extraInputs: {
      companyID: companyId || null,
      isActive: true
    }
  })

  const shownItems =
    data?.businessClientSuggestions?.items.filter((client) => !values.map(({ name }) => name).includes(client.name)) ||
    []

  const handleChange = (clients: GTBusinessClientAutocomplete[], pattern = ''): void => {
    onChange(clients.map((client) => ({ id: client.id, name: client.name })))
    setPattern(pattern)
  }

  return (
    <SelectTags
      placeholder={placeholder}
      values={values}
      label={label}
      onChange={handleChange}
      items={shownItems}
      getTagLabel={(client: GTBusinessClientAutocomplete): string => client.name}
      loading={loading || isDebouncing}
      error={error}
      shouldShowItems={shouldShowItems}
      {...props}
    />
  )
}
